/* LUXTEK — theme.js */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  var rvs = document.querySelectorAll('.rv');
  if (rvs.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      rvs.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
      rvs.forEach(function (el, i) {
        el.style.transitionDelay = ((i % 4) * 70) + 'ms';
        io.observe(el);
      });
    }
  }

  /* ---------- nav + temperature chip ---------- */
  var nav = document.getElementById('SiteNav');
  var hero = document.querySelector('.hero');
  var chip = null;
  var tempVal = null;

  /* ---------- mobile drawer ---------- */
  var burger = document.getElementById('NavBurger');
  var drawer = document.getElementById('NavDrawer');
  if (burger && drawer) {
    var setDrawer = function (open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', function () {
      setDrawer(drawer.getAttribute('data-open') !== 'true');
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760) setDrawer(false);
    });
  }
  var zones = Array.prototype.slice.call(document.querySelectorAll('[data-temp]'));
  var COOL = [122, 139, 153], HOT = [194, 65, 12], MIN = 72, MAX = 203;

  function mix(t) {
    var k = Math.max(0, Math.min(1, (t - MIN) / (MAX - MIN)));
    k = Math.pow(k, 0.85);
    return 'rgb(' + COOL.map(function (c, i) {
      return Math.round(c + (HOT[i] - c) * k);
    }).join(',') + ')';
  }

  function currentTemp() {
    if (!zones.length) return MIN;
    var mid = window.scrollY + window.innerHeight * 0.42;
    var prev = zones[0], next = zones[0];
    for (var i = 0; i < zones.length; i++) {
      var top = zones[i].getBoundingClientRect().top + window.scrollY;
      if (top <= mid) { prev = zones[i]; next = zones[i + 1] || zones[i]; }
    }
    var a = prev.getBoundingClientRect().top + window.scrollY;
    var b = next.getBoundingClientRect().top + window.scrollY;
    var ta = parseFloat(prev.dataset.temp), tb = parseFloat(next.dataset.temp);
    if (b <= a) return tb;
    var f = Math.max(0, Math.min(1, (mid - a) / (b - a)));
    return ta + (tb - ta) * f;
  }

  function tick() {
    if (chip && tempVal && zones.length) {
      var t = Math.round(currentTemp());
      var c = mix(t);
      tempVal.innerHTML = t + '&deg;';
      chip.style.color = c;
    }
    if (nav) {
      var threshold = 20;
      nav.classList.toggle('is-solid', window.scrollY > threshold);
    }
  }

  var raf = null;
  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { tick(); raf = null; });
  }, { passive: true });
  window.addEventListener('resize', tick);
  tick();

  if (chip && !zones.length) chip.style.display = 'none';

  /* ---------- settings toggle ---------- */
  var toggleRoot = document.querySelector('[data-settings-toggle]');
  if (toggleRoot) {
    var sceneImg = document.getElementById('SceneImg');
    var sceneWrap = sceneImg ? sceneImg.parentNode : null;
    var sceneTag = document.getElementById('SceneTag');
    var copy = document.getElementById('SetCopy');
    var setTitle = document.getElementById('SetTitle');
    var setBody = document.getElementById('SetBody');
    var setList = document.getElementById('SetList');
    var buttons = toggleRoot.querySelectorAll('button[data-set]');

    var render = function (btn) {
      if (setTitle) setTitle.textContent = btn.dataset.title || '';
      if (setBody) setBody.textContent = btn.dataset.body || '';
      if (sceneTag) {
        sceneTag.innerHTML = (btn.dataset.tag || '') +
          (btn.dataset.sub ? '<span>' + btn.dataset.sub + '</span>' : '');
      }
      if (sceneImg && btn.dataset.img) {
        sceneImg.src = btn.dataset.img;
        sceneImg.alt = btn.dataset.alt || '';
      }
      if (setList) {
        var rows = (btn.dataset.rows || '').split('|').filter(Boolean);
        setList.innerHTML = rows.map(function (r) {
          var p = r.split('::');
          return '<li><span>' + (p[0] || '') + '</span><span>' + (p[1] || '') + '</span></li>';
        }).join('');
      }
    };

    if (buttons.length) render(buttons[0]);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        btn.setAttribute('aria-selected', 'true');
        if (reduce) { render(btn); return; }
        if (sceneWrap) sceneWrap.classList.add('is-out');
        if (copy) copy.classList.add('is-out');
        setTimeout(function () {
          render(btn);
          if (sceneWrap) sceneWrap.classList.remove('is-out');
          if (copy) copy.classList.remove('is-out');
        }, 320);
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  var qas = document.querySelectorAll('.qa');
  qas.forEach(function (qa) {
    var btn = qa.querySelector('.qa__q');
    var panel = qa.querySelector('.qa__a');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = qa.classList.contains('is-open');
      qas.forEach(function (o) {
        o.classList.remove('is-open');
        var p = o.querySelector('.qa__a');
        if (p) p.style.maxHeight = null;
        var b = o.querySelector('.qa__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        qa.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- offer popup ---------- */
  var pop = document.getElementById('OfferPopup');
  if (pop) {
    var KEY = 'luxtek_offer_seen';
    var delay = parseInt(pop.dataset.delay, 10);
    if (isNaN(delay)) delay = 8;

    var seen = false;
    try { seen = window.localStorage.getItem(KEY) === '1'; } catch (e) { seen = false; }

    var close = function () {
      pop.classList.remove('is-open');
      try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
    };

    var open = function () {
      if (pop.classList.contains('is-open')) return;
      pop.classList.add('is-open');
      var input = pop.querySelector('input[type=email]');
      if (input) { try { input.focus(); } catch (e) {} }
    };

    if (!seen) {
      // Research-backed: a 6-10s delay outperforms an immediate display.
      setTimeout(open, delay * 1000);
    }

    pop.querySelectorAll('[data-pop-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
    });

    // If the visitor already subscribed, Shopify reloads with ?customer_posted=true
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
    }
  }

  /* ---------- sticky mobile CTA ---------- */
  var sticky = document.querySelector('[data-sticky-cta]');
  if (sticky) {
    sticky.addEventListener('click', function () {
      var target = document.getElementById('offer');
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    });
  }
})();
